import { html, nothing } from 'lit';
// import { HighlineService } from '@cof/auto-refinance-node-highline';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.js';
import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import '../customer-offer-banner/customer-offer-banner.component.js';
import '../key-requirements/key-requirements.component.js';
import '../steps/step-name/step-name.component.js';
import '../steps/step-communication/step-communication.component.js';
import '../steps/step-identity/step-identity.component.js';
import '../steps/step-address/step-address.component.js';
import '../steps/step-income/step-income.component.js';
import '../steps/step-employment/step-employment.component.js';
import '../steps/step-coborrower/step-coborrower.component.js';
import '../refi-error/refi-error.component.js';
import '../steps/step-iconic-income/step-iconic-income.component.js';
import '../steps/step-address-v2/step-address-v2.component.js';
import { RefiPersonal } from '../personal.component.js';
import '../edit-card/edit-card.component.js';
import '../steps/step-communication-v2/step-communication-v2.component.js';
import '../steps/step-employment-v2/step-employment-v2.component.js';
import { REFI_PERSONAL_CONST } from '../../shared/constants/app.constants.js';
import { ApplicationService } from '../../services/application.service.js';
import { DebugService } from '../../shared/services/debug.service.js';
import { stratum } from '../../../constants/stratum.js';
import { stateChangedEvent } from '../utils/host-app-events.js';
import { style } from '../personal.style.js';
import { globalStyle } from '../../global-styles.style.js';
import { links } from '../../styles/links.style.js';

export class RefiPersonalV2 extends RefiPersonal {
  MFE_NAME = 'personal';

  constructor() {
    super();
    this.debug = new DebugService('RefiPersonalV2Routing');
  }

  static properties = {
    loading: { type: Boolean },
    customerOffer: { type: Object, reflect: true },
    matchingState: { type: String, reflect: true },
    steps: { type: Array, reflect: true },
    currentSteps: { type: Array, reflect: true },
    currentStepIndex: { type: Number, reflect: true },
    initialSavePersonalInfo: { type: Boolean },
    missingPersonalInfo: { type: Boolean },
    consentAgree: { type: Boolean, reflect: true },
    currentStep: { type: String, reflect: true, attribute: 'current-step' },
  };

  static styles = [style, globalStyle, links, typographyStyles];

  updated() {
    // update currentStepIndex when currentStep changes
    if (this.currentStep !== this.currentSteps[this.currentStepIndex]) {
      this.currentStepIndex = this.currentSteps.indexOf(this.currentStep);
      this.debug.log('Updating current step index to', this.currentStepIndex);
      stateChangedEvent(this, this.currentSteps, this.currentStepIndex);
    }
  }

  onHashChange() {}

  initializePersonal() {
    this.setConsentModalTexts();
    this.debug.log('profileType', ApplicationService.Application.profileType);
    this._decisionCurrentSteps();
    ApplicationService.Application = {
      ...ApplicationService.Application,
      isPrefilled:
        ApplicationService.Application.profileType ===
        REFI_PERSONAL_CONST.FINANCIAL,
    };

    if (this.currentStep) {
      this.currentStepIndex = this.currentSteps.indexOf(this.currentStep);
    }

    this.debug.log(
      `Initializing personal, currentStep ${
        this.currentStep
      }, currentStepIndex ${this.currentStepIndex}, step ${
        this.currentSteps[this.currentStepIndex]
      }`
    );
    if (!this.currentStep) {
      stateChangedEvent(this, this.currentSteps, this.currentStepIndex, true);
    } else {
      this.currentStepIndex = this.currentSteps.indexOf(this.currentStep);
      stateChangedEvent(this, this.currentSteps, this.currentStepIndex, true);
    }
    // if (!HighlineService.publicKey) {
    //   HighlineService.urlPrefix = REFI_PERSONAL_CONST.HIGHLINE_URL_PREFIX();
    //   HighlineService.getPublicKey(
    //     REFI_PERSONAL_CONST.PREQUAL_BFF_HIGHLINE_PRODUCT_ID()
    //   );
    // }
    // ApplicationService.setMockApplication();
  }

  firstUpdated() {
    trackAnalyticsEvent(
      `loaded step ${this.currentSteps[this.currentStepIndex]}`
    );
    trackAnalyticsEvent(
      `profile ${ApplicationService.Application.profileType}`
    );
    stratum.publishTag(TagKey.PERSONAL_CUSTOMER_PROFILE_TYPE, {
      replacements: { value: ApplicationService.Application.profileType },
    });

    stratum.publishTag(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL);
    trackAnalyticsEvent(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL);
    stratum.publishTag(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_MODPREQUAL);
    trackAnalyticsEvent(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_MODPREQUAL);
  }

  checkIconicV2Steps() {
    if (!REFI_PERSONAL_CONST.isProdEnv()) {
      this.v2Param = new URL(window.location.href)?.searchParams?.get(
        'iconic-v2'
      );
      this.experimentParam = new URL(window.location.href).searchParams.get(
        'experiment'
      );

      this.mockParam = new URL(window.location.href)?.searchParams?.get(
        'mock-app'
      );

      if (this.v2Param || this.experimentParam === 'iconic-prequal-v2-only') {
        this.debug.log('Setting up iconic v2 steps');
        ApplicationService.isIconicV2 = true;

        if (this.mockParam) {
          ApplicationService.setMockApplication();
        }

        this.currentSteps = this.v2Steps;
        this.currentStepIndex = 0;
      }
    }
  }

  nextMfe() {
    const now = Date.now();
    this.debug.log('Attempting to send next-mfe event to host app');
    if (!this.lastNextMfeTime || now - this.lastNextMfeTime >= 1000) {
      // Throttles next-mfe event to only send at most once a second
      this.lastNextMfeTime = now;
      this.dispatchEvent(
        new CustomEvent('host-app-update-application', {
          bubbles: true,
          composed: true,
          detail: {
            data: { application: ApplicationService.Application },
          },
        })
      );
      this.dispatchEvent(
        new CustomEvent('next-mfe', {
          bubbles: true,
          composed: true,
          detail: {
            sentFrom: 'personal',
          },
        })
      );
      this.debug.log('next-mfe event sent to host app');
    } else {
      this.debug.log('next-mfe event throttled');
    }
  }

  lighthouseSetup() {
    if (!REFI_PERSONAL_CONST.isProdEnv()) {
      this.testingParam = new URL(window.location.href)?.searchParams?.get(
        'testing'
      );
      const lighthouseConstKey = Object.keys(
        REFI_PERSONAL_CONST.LIGHTHOUSE_QUERY_PARAM
      ).find(
        (key) =>
          REFI_PERSONAL_CONST.LIGHTHOUSE_QUERY_PARAM[key].paramValue ===
          this.testingParam
      );
      if (lighthouseConstKey) {
        const { stepIndex } = {
          ...REFI_PERSONAL_CONST.LIGHTHOUSE_QUERY_PARAM[lighthouseConstKey],
        };
        ApplicationService.setMockApplication();
        this.currentSteps = (
          lighthouseConstKey === 'COBORROWER'
            ? this.nonFinancialSteps
            : this.financialSteps
        ).concat(this.coborrowerSteps);
        this.currentStepIndex = stepIndex;
      }
    }
  }

  renderPage(pageName) {
    // if we fail to find a page, go back to the first page.
    this.debug.log('renderPage called with: ', pageName);
    if (pageName === undefined) {
      this.debug.log('page name undefined: ', pageName);
      return nothing;
    }
    const isCoApp = pageName.includes('co-app');
    if (isCoApp && ApplicationService.Application.applicationType !== 'JOINT') {
      this.nextStep();
      return nothing;
    }
    this.shouldShowBackButton(pageName);
    switch (pageName) {
      case 'name':
        return html` <refi-step-name
          customer-offer="${JSON.stringify(this.customerOffer)}"
          @next-step="${() => {
            this._decisionCurrentSteps();
            this.nextStep();
          }}"
        ></refi-step-name>`;
      case 'communication':
      case 'co-app-communication':
        return html` ${ApplicationService.isIconicV2
          ? html`<refi-step-communication-v2
              @next-step="${this.nextStep}"
            ></refi-step-communication-v2>`
          : html` <refi-step-communication
              @next-step="${this.nextStep}"
              ?is-prefill="${ApplicationService.Application.isPrefilled}"
              ?is-primary="${!isCoApp}"
            ></refi-step-communication>`}`;
      case 'identity':
      case 'co-app-identity':
        return html` <refi-step-identity
          @next-step="${this.nextStep}"
          ?is-prefill="${ApplicationService.Application.isPrefilled}"
          ?is-primary="${!isCoApp}"
        ></refi-step-identity>`;
      case 'address':
      case 'co-app-address':
        return html` ${ApplicationService.isIconicV2
          ? html`<refi-step-address-v2
              @next-step="${this.nextStep}"
              ?is-prefill="${ApplicationService.Application.isPrefilled}"
            ></refi-step-address-v2>`
          : html`<refi-step-address
              @next-step="${this.nextStep}"
              ?is-prefill="${ApplicationService.Application.isPrefilled}"
              ?is-primary="${!isCoApp}"
              ?is-iconic="${ApplicationService.isIconicAndToggledOn}"
            ></refi-step-address>`}`;
      case 'employment':
      case 'co-app-employment':
        return html` ${ApplicationService.isIconicV2
          ? html`<refi-step-employment-v2
              @next-step="${this.nextStep}"
              ?is-prefill="${ApplicationService.Application.isPrefilled}"
            ></refi-step-employment-v2>`
          : html` <refi-step-employment
              @next-step="${this.nextStep}"
              ?is-prefill="${ApplicationService.Application.isPrefilled}"
              ?is-primary="${!isCoApp}"
            ></refi-step-employment>`}`;
      case 'income':
      case 'co-app-income':
        return html` ${ApplicationService.isIconicAndToggledOn
          ? html`
              <refi-step-iconic-income
                ?is-prefill="${ApplicationService.Application.isPrefilled}"
                ?is-primary="${!isCoApp}"
                @next-step="${this.nextStep}"
              ></refi-step-iconic-income>
            `
          : html` <refi-step-income
              @next-step="${this.nextStep}"
              ?is-prefill="${ApplicationService.Application.isPrefilled}"
              ?is-primary="${!isCoApp}"
            ></refi-step-income>`}`;
      case 'coborrower':
        return html` <refi-step-coborrower
          @next-step="${() => {
            this._decisionCurrentSteps();
            this.nextStep();
          }}"
          ?is-prefill="${ApplicationService.Application.isPrefilled}"
        ></refi-step-coborrower>`;
      default:
        return nothing;
    }
  }

  render() {
    return html`
      <div class="main">
        <refi-track-pageview pagename="personal"></refi-track-pageview>
        <div ?hidden="${!this.customerOffer}">
          ${this.renderCustomerOfferBanner(
            this.currentSteps[this.currentStepIndex]
          )}
        </div>
        <div class="page-content">
          ${this.renderPage(this.currentSteps[this.currentStepIndex])}
        </div>
      </div>

      <fs-modal-dialog
        id="consent-modal"
        role="dialog"
        accessible-title="Let’s check your eligibility"
        mobile-layout="auto"
        aria-labelledby="consent-modal"
        size="small"
        dismissible
        @modal-dialog-open="${this.publishViewModal}"
        @modal-dialog-close="${this.publishCloseModal}"
      >
        <fs-heading
          class="modal-dialog-header"
          slot="modal-dialog-header"
          level="2"
          size="medium"
          variant="primary"
          >Let’s check your eligibility</fs-heading
        >
        <section
          class="fs-body-text fs-body-text--normal consent-modal-section"
          slot="modal-dialog-body"
        >
          <fs-body-text
            class="consent-modal-body-text"
            size="normal"
            variant="primary"
          >
            <span class="bold-text"
              >${this.consentModalPersonText} give Capital One permission to:
            </span>
          </fs-body-text>
          <fs-body-text size="normal" variant="primary">
            <ul class="consent-modal__list fs-body-text--normal">
              <li class="list_element">
                Get ${this.myOrOur} car info from state records
              </li>
              <li class="list_element">Confirm ${this.myOrOur} income</li>
              <li class="list_element">Pull ${this.myOrOur} credit reports</li>
            </ul>
          </fs-body-text>
          <fs-body-text size="normal" variant="primary">
            <span class="bold-text">(This won't impact your credit score)</span>
          </fs-body-text>
          <fs-body-text size="normal" variant="primary"
            >${this.iOrWe} agree to
            <a
              href="https://www.capitalone.com/privacy/"
              class="fs-link fs-link--primary"
              target="_blank"
              rel="noopener noreferrer"
              @click="${this.publishPrivacy}"
              >Capital One's Privacy Policies</a
            >
            and
            <a
              href="https://www.capitalone.com/bank/disclosures/eddn/"
              target="_blank"
              rel="noopener noreferrer"
              class="fs-link fs-link--primary"
              @click="${this.publishPaperless}"
              >Paperless Agreement</a
            >. ${this.iOrWe} understand ${this.iOrWe} must agree to both to
            apply for refinancing and that ${this.iOrWe} will receive all
            communications about ${this.myOrOur} refinance application and auto
            loan account electronically, not on paper.
          </fs-body-text>
        </section>
        <fs-modal-dialog-footer slot="modal-dialog-footer">
          <fs-button
            variant="primary"
            touched=""
            class="fs-button fs-button--primary modal-btn"
            @click="${this.clickedAgree}"
            ?loading="${this.consentAgree}"
          >
            ${this.iOrWe} agree</fs-button
          >
        </fs-modal-dialog-footer>
      </fs-modal-dialog>
    `;
  }
}

customElements.define('refi-personal-v2', RefiPersonalV2);
